import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "add", component: () => import("../components/Inicio") },
  { path: "/Envio_Edit/:envioID?", name: "EnvioEdit", props: true, component: () => import("../components/EnvioEditar") },
  { path: "/ingresar", name: "ingresar", component: () => import("../components/Ingresar") },
  { path: "/paquete/:pak?", name: "paquete", props: true, component: () => import("../components/Paquete") },
  { path: "/NoEntregado/:viaje?", name: "NoEntregado", props: true, component: () => import("../components/NoEntregado") },
  { path: "/OrdenEntregar/:viaje?", name: "OrdenEntregar", props: true, component: () => import("../components/OrdenEntregar") },
  { path: "/Manifiesto/:viaje?/:referencias?", name: "Manifiesto", props: true, component: () => import("../components/Manifiesto") },
  { path: "/Aereolinea/:viaje?", name: "Aereolinea", props: true, component: () => import("../components/Aereolinea") },
  { path: "/ConsolidarII/:viaje?", name: "ConsolidarII", props: true, component: () => import("../components/ConsolidarII") },
  { path: "/Consolidar/:viaje?", name: "Consolidar", props: true, component: () => import("../components/Consolidar") },
  { path: "/envio/:id?", name: "envio", props: true, component: () => import("../components/envio") },
  { path: "/courier/:opcion?/:referencia?", name: "courier", props: true, component: () => import("../components/courier") },
  { path: "/nosotros", name: "nosotros", component: () => import("../components/nosotros") },
  { path: "*", component: () => import("../components/404") },
];

const router = new VueRouter({ mode: "history", base: process.env.BASE_URL, routes });

export default router;
